/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import { currentCityId, esputnikTracker, eventEmitter, lang, sessid } from './common/baseData'

import './shops/style.css';
import './catalog/style.css';
import './catalog/basic.card';
import './common/styles/faq-list.css'
import './catalog/offers-list/colors.css';

import {SliderShop} from './shops/slider-shop';
import {BlogList} from './blog/blog-list';
import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom'
import ViewedProductsSlider from './components/viewedProductsSlider/ViewedProductsSlider'
import ShopsAccordeonList from './blocks/shopsAccordeonList/ShopsAccordeonList'

// Swiper slider / просмотренные товары
new ViewedProductsSlider().init()

let faqListNode = document.querySelector('.accordeon_items.faq_list_js');

if (faqListNode instanceof HTMLElement) {
	faqListNode.addEventListener('click', event => {
		let target = event.target;
		if (target.classList.contains('accordeon_head') || target.closest('.accordeon_head') instanceof HTMLElement) {
			let parentNode = target.closest('.accordeon_item');
			let contentNode = parentNode.querySelector('.accordeon_content');

			if (parentNode.classList.contains('active')) {
				parentNode.classList.remove('active');
				contentNode.style.display = '';
			} else {
				parentNode.classList.add('active');
				contentNode.style.display = 'block';
			}
		}
	});
}

// Список магазинов
let shopsNode = document.querySelector('.accordeon_items.shops_list_js');
if (shopsNode instanceof HTMLElement) (new ShopsAccordeonList({root: shopsNode})).init()

// Esputnik Tracker
let categoryId = (document.querySelector('[data-section]'))
	? document.querySelector('[data-section]').dataset.section
	: null;

eventEmitter.on('EsputnikLoaded', () => {
	esputnikTracker.CategoryPage(categoryId);
});

SliderShop.init();
BlogList.init();
